<template>
    <div>
        <filter-manager :current-saved-filters="savedFilters" vehicle-type="passenger"></filter-manager>

        <accordion>
            <accordion-section name="Date">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_date_year" class="Form__label">Year</label>
                            <div class="Form__select">
                                <select id="filter_date_year" v-model="filters.date.year">
                                    <option :value="year" v-for="year in years">{{ year }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_comparison_year" class="Form__label">Comparison</label>
                            <div class="Form__select">
                                <select id="filter_comparison_year" v-model="filters.comparison.year">
                                    <option value="-">Not Set</option>
                                    <option :value="year" v-for="year in years">{{ year }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_date_month_from" class="Form__label">Month From</label>
                            <div class="Form__select">
                                <select id="filter_date_month_from"
                                        v-model="filters.date.monthFrom"
                                        @change="resetDayFrom"
                                >
                                    <option :value="null">Not Set</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_date_month_to" class="Form__label">Month To</label>
                            <div class="Form__select">
                                <select id="filter_date_month_to"
                                        v-model="filters.date.monthTo"
                                        @change="resetDayTo"
                                >
                                    <option :value="null">Not Set</option>
                                    <option value="1">January</option>
                                    <option value="2">February</option>
                                    <option value="3">March</option>
                                    <option value="4">April</option>
                                    <option value="5">May</option>
                                    <option value="6">June</option>
                                    <option value="7">July</option>
                                    <option value="8">August</option>
                                    <option value="9">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_date_day_from" class="Form__label">Day From</label>
                            <div class="Form__select">
                                <select id="filter_date_day_from"
                                        v-model="filters.date.dayFrom"
                                        :disabled="disableDay(filters.date.monthFrom)"
                                >
                                    <option :value="null">Not Set</option>
                                    <option :value="day" v-for="day in days">{{ day }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="Form__group">
                            <label for="filter_date_day_to" class="Form__label">Day To</label>
                            <div class="Form__select">
                                <select id="filter_date_day_to"
                                        v-model="filters.date.dayTo"
                                        :disabled="disableDay(filters.date.monthTo)"
                                >
                                    <option :value="null">Not Set</option>
                                    <option :value="day" v-for="day in days">{{ day }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </accordion-section>

            <accordion-section name="Registration Type">
                <div class="Form__group">
                    <label class="Form__label">Registration Type</label>
                    <div class="Form__select">
                        <select v-model="filters.registration.type" @change="clearUsedImportFilters()">
                            <option value="new-total">Total New Registrations</option>
                            <option value="new-irish">New Irish Registrations</option>
                            <option value="new-irish-ex-car-hire">New Irish Registrations (ex. Car Hire)</option>
                            <option value="new-imports">New Imports</option>
                            <option value="used-imports">Used Imports</option>
                            <option value="hire-cars">Hire Cars</option>
                        </select>
                    </div>
                </div>

                <div class="Form__group" v-show="filters.registration.type == 'used-imports'">
                    <label class="Form__label">Age Profile</label>
                    <multiselect v-model="filters.registration.age"
                                 track-by="code"
                                 label="name"
                                 :options="[
                                     { name: 'Current Year', 'code': 0 },
                                     { name: '1 Year Old', 'code': 1 },
                                     { name: '2 Years Old', 'code': 2 },
                                     { name: '3 Years Old', 'code': 3 },
                                     { name: '4 Years Old', 'code': 4 },
                                     { name: '5 Years Old', 'code': 5 },
                                     { name: '6 Years Old', 'code': 6 },
                                     { name: '7 Years Old', 'code': 7 },
                                     { name: '8 Years Old', 'code': 8 },
                                     { name: '9 Years Old', 'code': 9 },
                                     { name: '10+ Years Old', 'code': 10 },
                                 ]"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Ages"
                    >
                    </multiselect>
                </div>

                <div class="Form__group" v-show="filters.registration.type == 'used-imports'">
                    <label class="Form__label">Imported From</label>
                    <multiselect v-model="filters.registration.importedFrom"
                                 track-by="code"
                                 label="name"
                                 :options="[
                                     { name: 'UK', 'code': 'UK' },
                                     { name: 'Japan', 'code': 'Japan' },
                                     { name: 'Europe', 'code': 'Europe' },
                                     { name: 'Rest of the World', 'code': 'Rest of the World' },
                                 ]"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Origins"
                    >
                    </multiselect>
                </div>

                <div class="Form__group" v-if="canViewSalesTypes">
                    <label class="Form__label">Sales Type</label>
                    <multiselect v-model="filters.registration.salesTypes"
                                 track-by="code"
                                 label="name"
                                 :options="salesTypes"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Sales Types"
                    >
                    </multiselect>
                </div>
            </accordion-section>

            <accordion-section name="Vehicle">
                <div class="Form__group">
                    <label class="Form__label">Make</label>
                    <multiselect v-model="filters.vehicle.makes"
                                 track-by="code"
                                 label="name"
                                 :options="makes"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 :limit="9999999999999999"
                                 placeholder="Select Makes"
                                 @input="getModels"
                                 @remove="removeMake"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Model</label>
                    <multiselect v-model="filters.vehicle.models"
                                 track-by="id"
                                 label="name"
                                 :options="models"
                                 :show-labels="false"
                                 group-values="models"
                                 group-label="make"
                                 :disabled="! hasModels"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 :limit="9999999999999999"
                                 :placeholder="modelsPlaceholder"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Body Types</label>
                    <multiselect v-model="filters.vehicle.bodyTypes"
                                 track-by="code"
                                 label="name"
                                 :options="bodyTypes"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Body Types"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Transmissions</label>
                    <multiselect v-model="filters.vehicle.transmissions"
                                 track-by="code"
                                 label="name"
                                 :options="transmissions"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Transmissions"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Engine Type</label>
                    <multiselect v-model="filters.vehicle.engineTypes"
                                 track-by="code"
                                 label="name"
                                 :options="engineTypes"
                                 :show-labels="false"
                                 group-values="items"
                                 group-label="group"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Engine Types"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">CO<sub>2</sub> (WLTP)</label>
                    <multiselect v-model="filters.vehicle.co2Wltp"
                                 track-by="id"
                                 label="name"
                                 :options="co2WltpBands"
                                 :show-labels="false"
                                 group-values="bands"
                                 group-label="group"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select CO2 Bands"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">CO<sub>2</sub> (NEDC)</label>
                    <multiselect v-model="filters.vehicle.co2"
                                 track-by="id"
                                 label="name"
                                 :options="co2Bands"
                                 :show-labels="false"
                                 group-values="bands"
                                 group-label="group"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select CO2 Bands"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Engine Capacity</label>
                    <multiselect v-model="filters.vehicle.engineCapacities"
                                 track-by="id"
                                 label="name"
                                 :options="engineCapacities"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Engine Capacities"
                    >
                    </multiselect>
                </div>

                <div class="Form__group">
                    <label class="Form__label">Colour</label>
                    <multiselect v-model="filters.vehicle.colours"
                                 track-by="code"
                                 label="name"
                                 :options="colours"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Colours"
                    >
                    </multiselect>
                </div>
            </accordion-section>

            <accordion-section name="Segment">
                <div class="Form__group">
                    <label class="Form__label">Segments</label>
                    <multiselect v-model="filters.segment.types"
                                 track-by="code"
                                 label="name"
                                 :options="segments"
                                 :show-labels="false"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Segments"
                    >
                    </multiselect>
                </div>
            </accordion-section>
            <accordion-section name="Geographic">
                <div class="Form__group">
                    <label class="Form__label">Counties</label>
                    <multiselect v-model="filters.geographic.counties"
                                 track-by="code"
                                 label="name"
                                 :options="counties"
                                 :show-labels="false"
                                 group-values="items"
                                 group-label="group"
                                 :multiple="true"
                                 :hide-selected="true"
                                 :close-on-select="false"
                                 placeholder="Select Counties"
                    >
                    </multiselect>
                </div>
            </accordion-section>
        </accordion>

        <div class="FilterControls">
            <a href="#"
               class="Button Button--max-width Button--vertical-margin"
               @click.prevent="filterResults()"
            >
                Filter Results
            </a>
            <a href="#"
               class="Button Button--danger Button--max-width Button--vertical-margin"
               @click.prevent="clearFilters"
            >
                Clear Filters
            </a>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import Filter from '../../mixins/filter'

    export default {
        data() {
            return {
                filters: {
                    date: {
                        year: '',
                        monthFrom: null,
                        dayFrom: null,
                        monthTo: null,
                        dayTo: null,
                    },
                    comparison: {
                        year: '',
                    },
                    vehicle: {
                        makes: [],
                        models: [],
                        colours: [],
                        bodyTypes: [],
                        engineTypes: [],
                        co2: [],
                        engineCapacities: [],
                        transmissions: [],
                    },
                    registration: {
                        type: 'new-total',
                        age: [],
                        importedFrom: [],
                        salesTypes: [],
                    },
                    segment: {
                        types: []
                    },
                    geographic: {
                        counties: []
                    },
                },
            }
        },

        mixins: [Filter],

        props: {
            makes: {
                type: Array,
                required: true,
            },

            colours: {
                type: Array,
                required: true,
            },

            engineTypes: {
                type: Array,
                required: true,
            },

            bodyTypes: {
                type: Array,
                required: true,
            },

            co2Bands: {
                type: Array,
                required: true,
            },

            co2WltpBands: {
                type: Array,
                required: true,
            },

            engineCapacities: {
                type: Array,
                required: true,
            },

            salesTypes: {
                type: Array,
                required: true,
            },

            segments: {
                type: Array,
                required: true,
            },

            counties: {
                type: Array,
                required: true,
            },

            transmissions: {
                type: Array,
                required: true,
            },

            savedFilters: {
                type: Array,
                required: true,
            },

            canViewSalesTypes: {
                type: Boolean,
                required: true,
            }
        },

        methods: {
            clearFilters() {
                this.filters = {
                    date: {
                        year: this.currentYear,
                        monthFrom: null,
                        dayFrom: null,
                        monthTo: null,
                        dayTo: null,
                    },
                    comparison: {
                        year: this.lastYear,
                    },
                    vehicle: {
                        makes: [],
                        models: [],
                        colours: [],
                        bodyTypes: [],
                        engineTypes: [],
                        co2: [],
                        co2Wltp: [],
                        engineCapacities: [],
                        transmissions: [],
                    },
                    registration: {
                        type: 'new-total',
                        age: [],
                        importedFrom: [],
                        salesTypes: [],
                    },
                    segment: {
                        types: []
                    },
                    geographic: {
                        counties: []
                    },
                }

                this.resetModels();

                this.filterResults()
            },
        },

        components: {
            Multiselect,
        },
    }
</script>